module.exports = {
    LANGUAGE_ES: 'es-ES',
    THIRD_STEP: 2,
    REASONS_FOR_CHANGE_QUESTION_ID: "200",
    MAX_ATTEMPTS: '2',
    QUESTION_204: '204',
    ANSWER_205: '205',
    ACCORDION_TYPE: 'accordion',
    QUESTION_TO_COHERENCE_CONTROL: {
        6: '6',
        11: '11',
        29: '29',
        204: '204',
        208: '208',
        304: '304',
        308: '308',
    },
    GENERAL_TEST_STUDY_ANSWER_WEIGHTS: {
        "209": 3,
        "210": 2,
        "211": 1,
        "212": 0,
    },
    PRIVATE_EQUITY_STUDY_ANSWER_WEIGHTS: {
        "7": 3,
        "8": 2,
        "9": 1,
        "10": 0,
    },
    PRIVATE_EQUITY_TAGGING_DATA: {
        0: {
            2:{
                nombrePagina: "tu-inviertes/test-mifid",
                tipoProceso: "proc-tu-inviertes-test-mifid",
                pasoProceso: "paso_3",
                detalleProceso: "cultura financiera",
                accionEvento:"respuesta-test-mifid-cultura financiera",
            },
            3:{
                nombrePagina: "tu-inviertes/test-mifid",
                tipoProceso: "proc-tu-inviertes-test-mifid",
                pasoProceso: "paso_4",
                detalleProceso: "cultura financiera",
                accionEvento:"respuesta-test-mifid-cultura financiera",
            },
            4:{
                nombrePagina: "tu-inviertes/test-mifid",
                tipoProceso: "proc-tu-inviertes-test-mifid",
                pasoProceso: "paso_5",
                detalleProceso: "cultura financiera",
                accionEvento:"respuesta-test-mifid-cultura financiera",
            },
            5:{
                nombrePagina: "tu-inviertes/test-mifid",
                tipoProceso: "proc-tu-inviertes-test-mifid",
                pasoProceso: "paso_6",
                detalleProceso: "experiencia en inversiones",
                accionEvento:"respuesta-test-mifid-experiencia en inversiones",
            },
        },
        1: {
            0:{
                nombrePagina: "tu-inviertes/test-mifid",
                tipoProceso: "proc-tu-inviertes-test-mifid",
                pasoProceso: "paso_7",
                detalleProceso: "objetivo de la inversion",
                accionEvento:"respuesta-test-mifid-objetivo de la inversion",
            },
            1:{
                nombrePagina: "tu-inviertes/test-mifid",
                tipoProceso: "proc-tu-inviertes-test-mifid",
                pasoProceso: "paso_8",
                detalleProceso: "horizonte temporal",
                accionEvento:"respuesta-test-mifid-horizonte temporal",
            },
            2:{
                nombrePagina: "tu-inviertes/test-mifid",
                tipoProceso: "proc-tu-inviertes-test-mifid",
                pasoProceso: "paso_9",
                detalleProceso: "capacidad para asumir pérdidas",
                accionEvento:"respuesta-test-mifid-capacidad para asumir pérdidas",
            },
        },
        2:{
            0:{
                nombrePagina: "tu-inviertes/test-mifid",
                tipoProceso: "proc-tu-inviertes-test-mifid",
                pasoProceso: "paso_10",
                detalleProceso: "ingresos y gastos",
                accionEvento:"respuesta-test-mifid-ingresos y gastos",
            },
            2: {
                nombrePagina: "tu-inviertes/test-mifid",
                tipoProceso: "proc-tu-inviertes-test-mifid",
                pasoProceso: "paso_12",
                detalleProceso: "inversion sobre tu patrimonio",
                accionEvento:"respuesta-test-mifid-inversion sobre tu patrimonio",
            },
            4:{
                nombrePagina: "tu-inviertes/test-mifid",
                tipoProceso: "proc-tu-inviertes-test-mifid",
                pasoProceso: "paso_14",
                detalleProceso: "expectativa de reserva",
                accionEvento:"respuesta-test-mifid-expectativa de reserva",
            },
        }
    },
    PRIVATE_EQUITY_TAGGING_MODAL_DATA:{
        1:{
            categoriaEvento: "proc-tu-inviertes-test-mifid",
            accionEvento: "modal evaluacion idoneidad"
        }
    },
    DEFAULT_REASON: 0,
    HISTORY_TYPE_TEST: [
        {
            TYPE_TEST: 1,
            DATE: '-'
        },
        {
            TYPE_TEST: 2,
            DATE: '-'
        },
        {
            TYPE_TEST: 4,
            DATE: '-'
        },
        {
            TYPE_TEST: 5,
            DATE: '-'
        },
        {
            TYPE_TEST: 3,
            DATE: ''
        },
        {
            TYPE_TEST: 6,
            DATE: '-'
        }
    ],
    QUESTIONS_TO_EVALUATE_TO_PREVIOUS_TEST: [
        '204', '208', '213', '217', '241', '245', '249', '253', '257', '261', '265', '269', '273', '277'
    ],
    QUESTIONS_TO_EVALUATE_TO_PREVIOUS_TEST_V3: [
        '304', '308', '313', '317', '341', '345', '349', '353', '357', '361', '365', '369', '373', '377'
    ],
    QUESTIONS_EQUIVALENCE_V3_V2 : {
        '304': '204',
        '308': '208',
        '313': '213',
        '317': '217',
        '341': '241',
        '345': '245',
        '349': '249',
        '353': '253',
        '357': '257',
        '361': '261',
        '365': '265',
        '369': '269',
        '373': '273',
        '377': '277'
    },
    QUESTION_TO_NOT_CLEAN: ['200', '204'],
    SPINNER_ANSWER_ICON: {
        '33': 'icon-depositos',
        '34': 'icon-conservar-patrimonio',
        '35': 'icon-incremento-moderado',
        '36': 'icon-incremento-significativo',
    },
    QUESTION_TYPE_ACCORDION: 'accordion',
    QUESTION_TYPE_RADIO: 'radio',
    QUESTION_TYPE_TEXT: 'text',
    QUESTION_TYPE_SPINNER: 'spinner',
    QUESTION_TYPE_BOXES: 'Boxes',
    QUESTION_TYPE_MODAL: 'modal',
    ALTERNATIVE_FUNDS_TEST_ID: 7,
};
